
const getDefaultState = () => {
  return {
    windowWidth: 0,
    windowHeight: 0
  }
}

const state = getDefaultState()

const mutations = {
  SET_W: (state, w) => {
    state.windowWidth = w
  },
  SET_H: (state, h) => {
    state.windowHeight = h
  }
}

const actions = {

  setwidth({ commit }, w) {
    return new Promise((resolve, reject) => {
      commit('SET_W', w)
      resolve()
    })
  },
  setheight({ commit }, h) {
    return new Promise((resolve, reject) => {
      commit('SET_H', h)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

